var _TextAlignmentFormatContextMenu;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { dhLeftAlign, dhCenterAlign, dhRightAlign } from '@deephaven/icons';
class TextAlignmentFormatContextMenu {
  /**
   * Gets the associated icon for a given alignment
   * @param alignment The text alignment
   * @returns The corresponding icon definition
   */
  static getIconForAlignment(alignment) {
    if (alignment === 'center') return dhCenterAlign;
    if (alignment === 'left') return dhLeftAlign;
    return dhRightAlign;
  }
}
_TextAlignmentFormatContextMenu = TextAlignmentFormatContextMenu;
_defineProperty(TextAlignmentFormatContextMenu, "defaultGroup", 10);
_defineProperty(TextAlignmentFormatContextMenu, "alignmentGroup", 20);
_defineProperty(TextAlignmentFormatContextMenu, "alignmentOptions", [{
  title: 'Default',
  alignment: null,
  group: _TextAlignmentFormatContextMenu.defaultGroup
}, {
  title: 'Left Align',
  alignment: 'left',
  icon: dhLeftAlign,
  group: _TextAlignmentFormatContextMenu.alignmentGroup
}, {
  title: 'Center Align',
  alignment: 'center',
  icon: dhCenterAlign,
  group: _TextAlignmentFormatContextMenu.alignmentGroup
}, {
  title: 'Right Align',
  alignment: 'right',
  icon: dhRightAlign,
  group: _TextAlignmentFormatContextMenu.alignmentGroup
}]);
export default TextAlignmentFormatContextMenu;
//# sourceMappingURL=TextAlignmentFormatContextMenu.js.map